'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
function getColor(color) {
  if (!color || !color.replace(/\s+/g, '')) return {};
  return { color: color };
}

exports.default = getColor;